/**
 * Simple and reliable clipboard helper
 */

/**
 * Copy text to clipboard using the most reliable method
 *
 * @param {string} text - The text to copy
 * @param {Function} onSuccess - Callback on success
 * @param {Function} onError - Callback on error
 */
export const copyToClipboard = (text, onSuccess, onError) => {
  // Method: document.execCommand - most reliable across browsers
  try {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    // Make the textarea out of viewport
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    // Focus and select the text
    textArea.focus();
    textArea.select();
    // Execute the copy command
    const success = document.execCommand("copy");
    // Remove the temporary element
    document.body.removeChild(textArea);
    if (success) {
      if (onSuccess) onSuccess();
      return true;
    } else {
      if (onError) onError(new Error("execCommand returned false"));
      return false;
    }
  } catch (err) {
    console.error("Clipboard error:", err);
    if (onError) onError(err);
    return false;
  }
};
